'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M269.4 142.1c5.4 3.9 10.5 8.1 15.4 12.6 14-6.1 29.3-9.8 45.4-10.5 55.5-59.2 134.3-96.1 221.8-96.1 13.3 0 24-10.7 24-24S565.3 0 552 0C436.3 0 333.6 55.9 269.4 142.1zm118.9 13.1c15.5 6.9 29.3 16.9 40.8 29 34.4-25.3 76.9-40.2 122.9-40.2 13.3 0 24-10.7 24-24s-10.7-24-24-24c-62.2 0-119.3 22.2-163.7 59.2zM455 224.8c2.9 7.2 5.1 14.8 6.6 22.6 9.5 3.2 18.5 7.3 27 12.3 18-12.4 39.8-19.6 63.4-19.6 13.3 0 24-10.7 24-24s-10.7-24-24-24c-36.5 0-70.1 12.2-97 32.8z', 'M0 384c0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0 1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60-61.9 0-112 50.1-112 112 0 7.1 .7 14.1 1.9 20.8-38.3 12.6-65.9 48.7-65.9 91.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;